import {
  getAuthSelfQueryKey,
  getAuthSelfQueryOptions,
} from '@api/endpoints/auth/get-auth-self'
import { UserProvider } from '@core/components/user-provider/UserProvider'
import { useAuthStore } from '@core/stores/auth-store'
import { ContentWithBottom } from '@design/components/layouts/content-with-bottom/ContentWithBottom'
import { PlatformAgentHost } from '@platform/features/agent/PlatformAgentHost'
import { AgentSurface } from '@platform/features/agent/window/AgentSurface'
import { ROUTES } from '@platform/router/paths'
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

function AuthenticatedLayout() {
  return (
    <UserProvider>
      <PlatformAgentHost>
        <ContentWithBottom className='pb-11' bottom={<AgentSurface />}>
          <Outlet />
        </ContentWithBottom>
      </PlatformAgentHost>
    </UserProvider>
  )
}

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: async ({ context: { queryClient } }) => {
    if (!useAuthStore.getState().isLogged())
      throw redirect({ to: ROUTES.signIn })

    if (
      queryClient.getQueryState(getAuthSelfQueryKey())?.fetchStatus !==
      'fetching'
    )
      await queryClient.ensureQueryData({
        ...getAuthSelfQueryOptions(),
        retry: queryClient.getDefaultOptions().queries?.retry,
      })
  },
  component: AuthenticatedLayout,
})
